import { Spinner } from "@climatepartner/components/Spinner";
import { ReactElement, Suspense } from "react";
import { Outlet } from "react-router-dom";

export {
  CommunicationCertificationPagesPage,
  CommunicationCreateCertificationPage,
  CommunicationCustomerInformationPage,
  CommunicationEditCertificationPage,
  CommunicationPage,
  CommunicationReportsPage,
  CommunicationTransparencyPage,
} from "./lazy-pages";

export const CommunicationRoute = (): ReactElement => (
  <Suspense fallback={<Spinner />}>
    <Outlet />
  </Suspense>
);
